import * as React from 'react';
import { UitkSpacing } from 'uitk-react-spacing';

var UitkProgressSimpleStep = function (_a) {
    var label = _a.label, labelTextClassName = _a.labelTextClassName, labelPartsClassName = _a.labelPartsClassName;
    return (React.createElement("span", null,
        React.createElement("span", { className: label.detailText ? labelTextClassName : '' }, label.text),
        label.detailText && (React.createElement(UitkSpacing, { padding: { inline: 'one' } },
            React.createElement("span", { className: labelPartsClassName }, "\u00B7"))),
        label.detailText && React.createElement("span", { className: labelPartsClassName }, label.detailText)));
};
UitkProgressSimpleStep.displayName = 'UitkProgressSimpleStep';

export { UitkProgressSimpleStep };
